module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-splash"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "adv-caption"
  }, [_vm._v("Create and play graphic adventures")]), _vm._v(" "), _c('div', {
    staticClass: "adv-signed-out-only "
  }, [_c('div', {
    staticClass: "adv-signed-out-only ",
    attrs: {
      "id": "firebaseui-auth-container"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "adv-skip",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("CANCEL")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "adv-logo"
  }, [_c('img', {
    staticClass: "logo-adventify",
    attrs: {
      "src": "images/logo.png"
    }
  }), _vm._v(" ADVENTIFY")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b44e638!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionSplashScreen.vue
// module id = 315
// module chunks = 0